export enum SmtpAccountProvider {
    PLAIN_SMTP = 'smtp',
    MICROSOFT = 'microsoft',
    GOOGLE = 'google',
}
